import { get } from 'lodash'
import Gallery from '~/modules/templates/models/Gallery'
import auth from '~/modules/auth/auth'

export default async function ({ route, redirect, store }) {
  const isFromLanding = route.query?.from === 'landing'
  const isTemplatePage = route.name === 'templates-id'
  const templateId = isTemplatePage ? route.params.id : null

  if (auth.isAuthenticated() && isFromLanding && templateId) {
    try {
      const clonedTemplateId = get(
        await Gallery.api().cloneTemplate(templateId),
        'response.data.templateId'
      )
      if (templateId) {
        return redirect({
          name: 'templates-id',
          params: {
            id: clonedTemplateId
          }
        })
      } else {
        return redirect({
          name: 'documents'
        })
      }
    } catch (e) {
      return redirect({
        name: 'documents'
      })
    }
  } else if (isFromLanding && templateId) {
    return redirect({
      path: '/auth',
      query: {
        fromUrl: route.fullPath
      }
    })
  }
}
